<template>
<div class="chapter">
<div class="inner_page">
<p class="noindents"><a id="page_x"></a>“Tobacco manufacturers are exposed to a strong narcotic odor . . . men breathe an atmosphere strongly impregnated with a poisonous substance, yet become insensible to its influence.”</p>
<p class="rightr">C. Turner Thackrah, “Effects of Arts, Trades,<br/>
  and Professions on Health and Longevity,” 1832</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// frontmatter03.vue?059bbbb4